import { render, staticRenderFns } from "./BCXUserBadge.vue?vue&type=template&id=15ab406c"
import script from "./BCXUserBadge.vue?vue&type=script&lang=ts&setup=true"
export * from "./BCXUserBadge.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./BCXUserBadge.vue?vue&type=style&index=0&id=15ab406c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports